// Copyright © 2021 Move Closer
import { TeaserBoxVersion, TeaserBoxWithoutTabs } from './TeaserBox.contracts';
import { ModuleAdditionalRows } from '../_contracts';
/**
 * Checks if the given TeaserBox version is a version without tabs.
 *
 * @param moduleVersion - The version of the TeaserBox module.
 * @returns `true` if the version is without tabs, otherwise `false`.
 */
export const isTeaserBoxWithoutTabs = (moduleVersion) => {
    return TeaserBoxWithoutTabs.includes(moduleVersion);
};
/**
 * Returns the number of articles for a given tab index.
 */
export const getArticlesCountForTab = (moduleVersion, index) => {
    switch (moduleVersion) {
        case TeaserBoxVersion['L-5S-text-list']:
            if (index === 0) {
                return 6;
            }
            else if (index === 1) {
                return 15;
            }
            break;
        case TeaserBoxVersion['L-4S-text-list']:
            if (index === 0) {
                return 5;
            }
            else if (index === 1) {
                return 15;
            }
            break;
        case TeaserBoxVersion['XL-slider-3S-text-list']:
            if (index === 0) {
                return 12;
            }
            else if (index === 1) {
                return 20;
            }
            break;
    }
    return 10;
};
/**
 * Counts the articles for the passed-in version.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getArticlesCountPerTab = (moduleVersion, config) => {
    switch (moduleVersion) {
        case TeaserBoxVersion['1XL']: {
            return 1;
        }
        case TeaserBoxVersion['2L']: {
            return 2;
        }
        case TeaserBoxVersion['4S']: {
            return 4;
        }
        case TeaserBoxVersion['8T']: // deprecated
        case TeaserBoxVersion['8S']: {
            return 8;
        }
        case TeaserBoxVersion['6S-text-list']: {
            if (!config) {
                return 14;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 22;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 28;
            }
            return 14;
        }
        case TeaserBoxVersion['L-5S-text-list']: // deprecated
        case TeaserBoxVersion['L-4S-text-list']:
        case TeaserBoxVersion['XL-slider-3S-text-list']: {
            return getArticlesCountForTab(moduleVersion, 0) +
                getArticlesCountForTab(moduleVersion, 1);
        }
        case TeaserBoxVersion['L-4S-text-list-tabs']: {
            if (!config) {
                return 15;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 21;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 27;
            }
            return 15;
        }
        case TeaserBoxVersion['XL-3S-text-list']: {
            if (!config) {
                return 20;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 24;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 28;
            }
            return 20;
        }
        // deprecated variants
        case TeaserBoxVersion['L-4S']: { // deprecated
            return 5;
        }
        case TeaserBoxVersion['L-8S']: { // deprecated
            return 13;
        }
        case TeaserBoxVersion['L-2S-text-list']: { // deprecated
            return 11;
        }
        case TeaserBoxVersion['L-2S-thumbnails-list']: { // deprecated
            return 9;
        }
        case TeaserBoxVersion['6S-thumbnails-list']: { // deprecated
            if (!config) {
                return 12;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 18;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 24;
            }
            return 12;
        }
        case TeaserBoxVersion['L-2S-big-thumbnails-list']: { // deprecated
            return 7;
        }
        case TeaserBoxVersion['6S-big-thumbnails-list']: { // deprecated
            if (!config) {
                return 10;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 16;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 21;
            }
            return 10;
        }
        case TeaserBoxVersion['6T-text-list']: { // deprecated
            if (!config) {
                return 16;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addOne) {
                return 24;
            }
            if (config.additionalRows && config.additionalRows === ModuleAdditionalRows.addTwo) {
                return 31;
            }
            return 16;
        }
        default: {
            return 10;
        }
    }
};
/**
 * Counts the articles for the passed-in version and tabs configuration.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const getArticlesCount = (moduleVersion, tabsCount, config) => {
    if (isTeaserBoxWithoutTabs(moduleVersion)) {
        let totalArticles = 0;
        for (let index = 0; index < tabsCount; index++) {
            totalArticles += getArticlesCountForTab(moduleVersion, index);
        }
        return totalArticles;
    }
    return getArticlesCountPerTab(moduleVersion, config) * tabsCount;
};
